export * from "./IEasyTemplateProps";
export * from "./IClient";
export * from "./IStrings";
export * from "./ITemplate";
export * from "./OfficeTypes";